export default __webpack_public_path__ + "static/chopcryptos-779663ed68e60bdbcc2722162183c7e2.png";